import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';

const PricingCard = ({ name, price, target, employees, modules, highlight = false, delay = 0 }) => {
    const cardRef = useRef(null);

    useEffect(() => {
        if (cardRef.current) {
            cardRef.current.style.transitionDelay = `${delay}s`;
        }
    }, [delay]);

    return (
        <div
            ref={cardRef}
            className={`rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl ${highlight ? 'border-2 border-primary-500 relative' : 'border border-gray-200'
                }`}
        >
            {highlight && (
                <div className="bg-primary-500 text-white text-center py-1 text-sm font-medium">
                    最受歡迎
                </div>
            )}

            <div className="p-6">
                <h3 className="text-2xl font-bold mb-2">{name}</h3>
                <p className="text-gray-600 mb-4">{target}</p>
                <p className="text-4xl font-bold mb-2">{price}</p>
                <p className="text-gray-600 mb-6">每月 / {employees}</p>

                <div className="border-t border-gray-200 pt-6">
                    <p className="font-medium mb-4">包含模組：</p>
                    <ul className="space-y-3">
                        {modules.map((module, idx) => (
                            <li key={idx} className="flex items-start">
                                <Check size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" />
                                <span>{module}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="bg-gray-50 p-6">
                <Link
                    to="/contact"
                    className={`block text-center py-3 rounded-lg font-medium ${highlight
                            ? 'bg-primary-600 text-white hover:bg-primary-700'
                            : 'border border-primary-600 text-primary-600 hover:bg-primary-50'
                        }`}
                >
                    開始免費試用
                </Link>
            </div>
        </div>
    );
};

export default PricingCard;